var _g, _rect, _path, _rect2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPapaPointsGold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 75,
    viewBox: "0 0 61 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_118_2718)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.612 28.7162L49.2162 51.4775C48.3304 54.2016 45.8117 56.0319 42.9462 56.0319H19.0137C16.1482 56.0319 13.6295 54.2016 12.7437 51.4775L5.34787 28.7162C4.46207 25.9921 5.42524 23.0279 7.74379 21.3444L27.1059 7.27567C28.2639 6.43256 29.6219 6.01367 30.9799 6.01367C32.338 6.01367 33.696 6.43523 34.8566 7.27567L54.2188 21.3444C56.5373 23.0279 57.5005 25.9895 56.6147 28.7162H56.612Z",
    fill: "url(#paint0_linear_118_2718)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.6403 18.3376L36.2894 5.00265C32.7942 2.46266 28.0957 2.46266 24.6006 5.00265L6.24697 18.3376C2.75181 20.8776 1.30038 25.344 2.63441 29.4555L9.64342 51.0321C10.9774 55.1409 14.7794 57.9023 19.1017 57.9023H41.7856C46.1078 57.9023 49.9072 55.1409 51.2439 51.0321L58.2529 29.4555C59.5896 25.3466 58.1381 20.8776 54.6403 18.3376ZM54.739 28.3135L47.73 49.8902C46.8922 52.4728 44.5017 54.2071 41.7856 54.2071H19.1017C16.3856 54.2071 13.9977 52.4728 13.1573 49.8902L6.14825 28.3135C5.31048 25.7308 6.22029 22.924 8.41878 21.3259L26.7697 7.99355C27.869 7.1958 29.155 6.79559 30.441 6.79559C31.727 6.79559 33.0157 7.1958 34.1149 7.99355L52.4685 21.3285C54.6643 22.924 55.5795 25.7335 54.739 28.3162V28.3135Z",
    fill: "url(#paint1_linear_118_2718)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_118_2718)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.3029 32.0516C16.2655 32.3637 16.3643 32.6786 16.575 32.916C16.8952 33.2762 17.4261 33.3883 17.8637 33.1882L21.1134 31.6967L24.3631 33.1882C24.5099 33.2549 24.6646 33.2896 24.8247 33.2896C25.1395 33.2896 25.441 33.1535 25.6518 32.916C25.8599 32.6812 25.9586 32.3664 25.9239 32.0543L25.5104 28.5031L27.9303 25.875C28.2025 25.5815 28.2932 25.1626 28.1704 24.7838C28.0477 24.4049 27.7275 24.1194 27.3353 24.0394L23.8295 23.335L22.0766 20.2187C21.8791 19.8719 21.511 19.6558 21.1134 19.6558C20.7159 19.6558 20.345 19.8719 20.1476 20.2187L18.3947 23.3324L14.8888 24.0367C14.4966 24.1168 14.1764 24.3996 14.0537 24.7811C13.931 25.16 14.0217 25.5789 14.2938 25.8723L16.7164 28.5031L16.3029 32.0516Z",
    fill: "url(#paint2_linear_118_2718)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3029 32.0516C16.2655 32.3637 16.3643 32.6786 16.575 32.916C16.8952 33.2762 17.4261 33.3883 17.8637 33.1882L21.1134 31.6967L24.3631 33.1882C24.5099 33.2549 24.6646 33.2896 24.8247 33.2896C25.1395 33.2896 25.441 33.1535 25.6518 32.916C25.8599 32.6812 25.9586 32.3664 25.9239 32.0543L25.5104 28.5031L27.9303 25.875C28.2025 25.5815 28.2932 25.1626 28.1704 24.7838C28.0477 24.4049 27.7275 24.1194 27.3353 24.0394L23.8295 23.335L22.0766 20.2187C21.8791 19.8719 21.511 19.6558 21.1134 19.6558C20.7159 19.6558 20.345 19.8719 20.1476 20.2187L18.3947 23.3324L14.8888 24.0367C14.4966 24.1168 14.1764 24.3996 14.0537 24.7811C13.931 25.16 14.0217 25.5789 14.2938 25.8723L16.7164 28.5031L16.3029 32.0516Z",
    stroke: "url(#paint3_linear_118_2718)",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_118_2718)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.7906 24.7808C46.6678 24.402 46.3477 24.1165 45.9555 24.0365L42.4496 23.3321L40.6967 20.2158C40.4993 19.8689 40.1311 19.6528 39.7335 19.6528C39.336 19.6528 38.9651 19.8689 38.7677 20.2158L37.0148 23.3294L33.5089 24.0338C33.1167 24.1138 32.7966 24.3966 32.6738 24.7782C32.5511 25.157 32.6418 25.5759 32.914 25.8694L35.3366 28.5001L34.923 32.0487C34.8857 32.3608 34.9844 32.6756 35.1952 32.9131C35.5153 33.2733 36.0463 33.3854 36.4838 33.1852L39.7335 31.6938L42.9832 33.1852C43.13 33.252 43.2847 33.2866 43.4448 33.2866C43.7596 33.2866 44.0611 33.1506 44.2719 32.9131C44.48 32.6783 44.5787 32.3635 44.544 32.0513L44.1305 28.5001L46.5504 25.8721C46.8226 25.5786 46.9133 25.1597 46.7906 24.7808Z",
    fill: "url(#paint4_linear_118_2718)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.7906 24.7808C46.6678 24.402 46.3477 24.1165 45.9555 24.0365L42.4496 23.3321L40.6967 20.2158C40.4993 19.8689 40.1311 19.6528 39.7335 19.6528C39.336 19.6528 38.9651 19.8689 38.7677 20.2158L37.0148 23.3294L33.5089 24.0338C33.1167 24.1138 32.7966 24.3966 32.6738 24.7782C32.5511 25.157 32.6418 25.5759 32.914 25.8694L35.3366 28.5001L34.923 32.0487C34.8857 32.3608 34.9844 32.6756 35.1952 32.9131C35.5153 33.2733 36.0463 33.3854 36.4838 33.1852L39.7335 31.6938L42.9832 33.1852C43.13 33.252 43.2847 33.2866 43.4448 33.2866C43.7596 33.2866 44.0611 33.1506 44.2719 32.9131C44.48 32.6783 44.5787 32.3635 44.544 32.0513L44.1305 28.5001L46.5504 25.8721C46.8226 25.5786 46.9133 25.1597 46.7906 24.7808Z",
    stroke: "url(#paint5_linear_118_2718)",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_118_2718)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.4605 40.2076C37.3377 39.8287 37.0176 39.5433 36.6254 39.4632L33.1195 38.7589L31.3666 35.6426C31.1692 35.2957 30.801 35.0796 30.4035 35.0796C30.0059 35.0796 29.635 35.2957 29.4376 35.6426L27.6847 38.7562L24.1789 39.4605C23.7867 39.5406 23.4665 39.8234 23.3438 40.2049C23.221 40.5838 23.3117 41.0027 23.5839 41.2962L26.0065 43.9269L25.5929 47.4754C25.5556 47.7876 25.6543 48.1024 25.8651 48.3399C26.1852 48.7001 26.7162 48.8121 27.1537 48.612L30.4035 47.1206L33.6532 48.612C33.7999 48.6787 33.9546 48.7134 34.1147 48.7134C34.4296 48.7134 34.731 48.5773 34.9418 48.3399C35.1499 48.1051 35.2487 47.7902 35.214 47.4781L34.8004 43.9269L37.2204 41.2988C37.4925 41.0054 37.5832 40.5865 37.4605 40.2076Z",
    fill: "url(#paint6_linear_118_2718)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4605 40.2076C37.3377 39.8287 37.0176 39.5433 36.6254 39.4632L33.1195 38.7589L31.3666 35.6426C31.1692 35.2957 30.801 35.0796 30.4035 35.0796C30.0059 35.0796 29.635 35.2957 29.4376 35.6426L27.6847 38.7562L24.1789 39.4605C23.7867 39.5406 23.4665 39.8234 23.3438 40.2049C23.221 40.5838 23.3117 41.0027 23.5839 41.2962L26.0065 43.9269L25.5929 47.4754C25.5556 47.7876 25.6543 48.1024 25.8651 48.3399C26.1852 48.7001 26.7162 48.8121 27.1537 48.612L30.4035 47.1206L33.6532 48.612C33.7999 48.6787 33.9546 48.7134 34.1147 48.7134C34.4296 48.7134 34.731 48.5773 34.9418 48.3399C35.1499 48.1051 35.2487 47.7902 35.214 47.4781L34.8004 43.9269L37.2204 41.2988C37.4925 41.0054 37.5832 40.5865 37.4605 40.2076Z",
    stroke: "url(#paint7_linear_118_2718)",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 55.5,
    width: 29,
    height: 19,
    rx: 4.5,
    fill: "url(#paint8_linear_118_2718)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.79 70.14C25.652 70.14 26.744 69.104 26.744 65.1C26.744 61.32 25.652 60.06 23.79 60.06C21.928 60.06 20.836 61.32 20.836 65.1C20.836 69.104 21.928 70.14 23.79 70.14ZM23.79 68.236C23.356 68.236 23.104 67.984 23.104 65.1C23.104 62.216 23.356 61.964 23.79 61.964C24.224 61.964 24.476 62.216 24.476 65.1C24.476 67.984 24.224 68.236 23.79 68.236ZM31.9902 65.282C31.9622 65.142 31.9902 65.058 32.1022 64.974C32.6062 64.596 32.9142 63.98 32.9142 62.874C32.9142 60.914 31.7942 60.2 30.3662 60.2H27.6362V69.692C27.6362 69.888 27.7482 70 27.9442 70H29.8482V66.15C29.8482 66.066 29.9042 66.01 29.9882 66.01C30.0722 66.01 30.1142 66.052 30.1282 66.136L30.7302 69.72C30.7582 69.902 30.8842 70 31.0662 70H33.0822L31.9902 65.282ZM29.8482 64.4V61.964H30.1002C30.5762 61.964 30.7582 62.202 30.7582 63.182C30.7582 64.162 30.5762 64.4 30.1002 64.4H29.8482ZM36.4775 70.14C38.3395 70.14 39.4315 69.104 39.4315 65.1C39.4315 61.32 38.3395 60.06 36.4775 60.06C34.6155 60.06 33.5235 61.32 33.5235 65.1C33.5235 69.104 34.6155 70.14 36.4775 70.14ZM36.4775 68.236C36.0435 68.236 35.7915 67.984 35.7915 65.1C35.7915 62.216 36.0435 61.964 36.4775 61.964C36.9115 61.964 37.1635 62.216 37.1635 65.1C37.1635 67.984 36.9115 68.236 36.4775 68.236Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 55.5,
    width: 29,
    height: 19,
    rx: 4.5,
    stroke: "url(#paint9_linear_118_2718)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_118_2718",
    x: 5,
    y: 10.6558,
    width: 36.2246,
    height: 35.6338,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_118_2718"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_118_2718",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_118_2718",
    x: 23.6201,
    y: 10.6528,
    width: 36.2246,
    height: 35.6338,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_118_2718"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_118_2718",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_118_2718",
    x: 14.29,
    y: 26.0796,
    width: 36.2246,
    height: 35.6338,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_118_2718"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_118_2718",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_118_2718",
    x1: 5.02236,
    y1: 31.0241,
    x2: 56.9375,
    y2: 31.0241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A48235"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#A38542"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#A28D5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#BDA36A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#DFBF7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9CE8E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_118_2718",
    x1: 2.14349,
    y1: 30.4987,
    x2: 58.7438,
    y2: 30.4987,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A48235"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#B2964C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#CEBE7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#D9CE8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#D7CC8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#D1C587"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#C7B97E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#B9A871"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#A79261"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A28D5D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_118_2718",
    x1: 14.003,
    y1: 26.47,
    x2: 28.2238,
    y2: 26.47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4B4B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#C1C1C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_118_2718",
    x1: 21.1134,
    y1: 33.5537,
    x2: 21.1134,
    y2: 19.3863,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4B4B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#C1C1C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_118_2718",
    x1: 32.6231,
    y1: -0.370985,
    x2: 46.8439,
    y2: -0.370985,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4B4B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#C1C1C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_118_2718",
    x1: 39.7335,
    y1: 33.5534,
    x2: 39.7335,
    y2: 19.386,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4B4B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#C1C1C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_118_2718",
    x1: 23.2931,
    y1: 41.8965,
    x2: 37.5138,
    y2: 41.8965,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4B4B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#C1C1C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_118_2718",
    x1: 30.4035,
    y1: 48.9802,
    x2: 30.4035,
    y2: 34.8128,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4B4B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#C1C1C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_118_2718",
    x1: 15.5,
    y1: 65,
    x2: 45.5,
    y2: 65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A48235"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.348765,
    stopColor: "#A28D5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.681431,
    stopColor: "#DFBF7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9CE8E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_118_2718",
    x1: 15.5,
    y1: 55,
    x2: 48.513,
    y2: 64.2712,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFBF7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A48235"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_118_2718"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 61,
    height: 61,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPapaPointsGold);
export default __webpack_public_path__ + "static/media/papa_points_gold.6f1679aa841e8362d6ba96c65618869d.svg";
export { ForwardRef as ReactComponent };